import { Grid, useMediaQuery } from "@mui/material";
import {
  CmpButton,
  CmpDatePicker,
  CmpSelectBox,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { fAlertToast, fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import {
  PhysicalStockCount_Post_Generate,
  PhysicalStockCount_Variance_Comparision,
  PhysicalStockCount_Variance_Counting,
  PhysicalStockCount_Variance_Generate,
  PhysicalStockCount_onLoad_Attribute,
} from "../../Server/ApiV2";
import { getGlobals } from "../../Configs";
import { vRdxUserInfo } from "../../Redux/roStore";

export default function WmsPhysicalStockVariance() {
  const LocationFocusOnLoad = useRef(null);

  const vMediaQuery = useMediaQuery("(max-width:650px)"); 
  const [sNewAttribute,setNewAttribute]=useState({
    Location:[]
  })
  const [sSummaryObj, setSummaryObj] = useState({
    loc: "",
    RefNo: "",
  });
  const [baseUrl,setBaseUrl ] = useState( process.env.NODE_ENV !== 'production' ? getGlobals().API_BASE_URL+"/": getGlobals().API_BASE_URL);

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fLoad = (e) => {
    // Get_Summary();
  };
  const onload =async (e) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var obj = {
      userCd: vRdxUserInfoObj.UserID,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const iResp = await PhysicalStockCount_onLoad_Attribute(FinalObj);
    if (iResp?.status == 200) {
      setNewAttribute(iResp?.data.ResultSet);
      setSummaryObj((obj)=>({
        ...obj,
        loc:iResp?.data.ResultSet.Location[0].UID
      }))
      return iResp?.data.ResultSet;
    }
  };

  useEffect(() => {
    onload();
  }, []);

  const Generate_Variance = async () => {
    if (
      sSummaryObj.RefNo == "" ||
      sSummaryObj.RefNo == null ||
      sSummaryObj.RefNo == undefined
    ) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Reference Number is empty");
    } else if (
      sSummaryObj.loc == "" ||
      sSummaryObj.loc == null ||
      sSummaryObj.loc == undefined
    ) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      confirmAlert({
        title: "Generate Variance",
        message: "Are you want to Generate Variance.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: async () => {
              var vSummaryObj = {
                v_Loc:  sSummaryObj?.loc,
                v_RefNo: sSummaryObj.RefNo,
              };
              const resp = await PhysicalStockCount_Variance_Generate(
                vSummaryObj
              );
              if (resp?.status == 200) {
                fAlertToast("SUCCESS", "Successfully variance generated");
              }
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };
  const Post_Variance = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    if (
      sSummaryObj.RefNo == "" ||
      sSummaryObj.RefNo == null ||
      sSummaryObj.RefNo == undefined
    ) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Reference Number is empty");
    } else if (
      sSummaryObj.loc == "" ||
      sSummaryObj.loc == null ||
      sSummaryObj.loc == undefined
    ) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      confirmAlert({
        title: "Post Variance",
        message: "Are you want to Post Variance.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: async () => {
              var vSummaryObj = {
                v_Loc: sSummaryObj?.loc,
                v_UserId: vRdxUserInfoObj.UserID,
                v_IP: vRdxUserInfoObj.IP,
                v_RefNo: sSummaryObj.RefNo,
              };

              const resp = await PhysicalStockCount_Post_Generate(vSummaryObj);
              if (resp?.status == 200) {
                fAlertToast("SUCCESS", "Successfully variance posted");
              }
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };
  const StockWMS_RP = async () => {
    if (!sSummaryObj.loc) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/PhysicalStockCount_StockWMS_VS_RP?A_Loc=${
          sSummaryObj.loc
        }`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/PhysicalStockCount_StockWMS_VS_RP?A_Loc=${
        sSummaryObj.loc
      }`;
    }
  };
  const CardidWiseVariance = async () => {
    if (!sSummaryObj.loc) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/fPhysicalStockCount_onload_CARDID_GETROW?A_Loc=${
          sSummaryObj.loc
        }`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/fPhysicalStockCount_onload_CARDID_GETROW?A_Loc=${
        sSummaryObj.loc
      }`;
    }
  };
  const ItemWiseVariance
  = async () => {
    if (!sSummaryObj.loc) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/fPhysicalStockCount_onload_CARDID_GETROW?A_Loc=${
          sSummaryObj.loc
        }`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/fPhysicalStockCount_onload_CARDID_GETROW?A_Loc=${
        sSummaryObj.loc
      }`;
    }
  };
  const Counting_Variance = async () => {
    if (!sSummaryObj.RefNo) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Reference Number is empty");
    } else if (!sSummaryObj.loc) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/PhysicalStockCount_Variance_Counting?A_RefNo=${
          sSummaryObj.RefNo
        }&A_Loc=${sSummaryObj.loc}&isPending=N`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/PhysicalStockCount_Variance_Counting?A_RefNo=${
        sSummaryObj.RefNo
      }&A_Loc=${sSummaryObj.loc}&isPending=N`;
    }
  };
  const Comparision_Variance = async () => {
    if (!sSummaryObj.RefNo) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Reference Number is empty");
    } else if (!sSummaryObj.loc) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Location is empty");
    } else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/PhysicalStockCount_Variance_Comparision?v_A_RefNo=${
          sSummaryObj.RefNo
        }&A_Loc=${sSummaryObj.loc}`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/PhysicalStockCount_Variance_Comparision?v_A_RefNo=${
        sSummaryObj.RefNo
      }&A_Loc=${sSummaryObj.loc}`;
    }
  };
  const Physical_WMS_Rp = async () => {
    if (!sSummaryObj.RefNo) {
      // If any of the fields are empty, prevent navigation
      fAlertToast("FAILED", "Reference Number is empty");
    }   else {
      // If fields are not empty, navigate to the link
      console.log(
        "href",
        `${
          baseUrl
        }physicalstock/fPhysicalStockCount_PhysicalWMS_RP_V1?A_Loc=${
          sSummaryObj.loc
        }`
      );
      window.location.href = `${
        baseUrl
      }physicalstock/fPhysicalStockCount_PhysicalWMS_RP_V1?A_Loc=${
        sSummaryObj.loc
      }`;
    }
  };
  return (
    <div className="container-fluid my-3">
      <div className="PhysicalStock-detail">
        <>
          <Grid
            container
            spacing={{ xs: 2, sm: 2, md: 2 }}
            className="align-items-center"
            columns={{ xs: 12, sm: 12, md: 12 }}
          >
            <Grid item md={4} xs={3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item md={8} xs={9}>
              <CmpSelectBox
                xref={LocationFocusOnLoad}
                xLabelText="Location"
                xValue={sSummaryObj.loc}
                xOnChange={(event) => fSummary_OnChange(event)}
                xName={"loc"}
                xData={sNewAttribute.Location}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={false}
                xDisable={false}
              />
            </Grid>

            <Grid item md={4} xs={3}>
              <CmpTypographyField xcomponent={"span"} xText={"Reference No"} />
            </Grid>
            <Grid item md={8} xs={9} className="bintransfer-data-date">
              <CmpTextFieldEnter
                xLabelText={"Reference No"}
                xVariant={"outlined"}
                xValue={sSummaryObj.RefNo}
                xOnChange={(event) => fSummary_OnChange(event)}
                xReadOnly={false}
                xType={"text"}
                xName={"RefNo"}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter") {
                    fLoad();
                  }
                }}
                xOnEnter={(e) => {
                  if (e.key === "Enter") {
                    fLoad();
                  }
                }}
                xSmShow={!!vMediaQuery}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
              {/* <CmpButton
                xbtnName="Counting Status"
                xOnClick={Counting_Variance}
                xVariant="contained"
                xSize="small"
              /> */}
              <a
                href="#!"
                onClick={Counting_Variance}
                // href={`${
                //   getGlobals().API_BASE_URL
                // }/physicalstock/PhysicalStockCount_Variance_Counting?A_RefNo=${
                //   sSummaryObj.RefNo
                // }&A_Loc=${sSummaryObj.loc}&isPending=Y`}
              >
                Counting Status
              </a>
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              justifyContent={"center"}
              textAlign={"center"}
              className="bintransfer-data-date  "
            >
              {/* <CmpButton
                xbtnName="Comparision Status"
                xOnClick={Comparision_Variance}
                xVariant="contained"
                xSize="small"
              /> */}
              <a
                href="#!"
                onClick={Comparision_Variance}
                // href={`${
                //   getGlobals().API_BASE_URL
                // }/physicalstock/PhysicalStockCount_Variance_Comparision?v_A_RefNo=${
                //   sSummaryObj.RefNo
                // }&A_Loc=${sSummaryObj.loc}`}
              >
                Comparision Status
              </a>
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
               
              <a
                href="#!"
                onClick={CardidWiseVariance}
                
              >
                Cardid wise variance
              </a>
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
               
              <a
                href="#!"
                onClick={ItemWiseVariance}
                
              >
               Item wise variance
              </a>
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              className="bintransfer-data-date  "
              justifyContent={"center"}
              textAlign={"center"}
            >
              {/* <CmpButton
                xbtnName=" Physical vs WMS vs RP"
                xOnClick={Physical_WMS_Rp}
                xVariant="contained"
                xSize="small"
              /> */}
              <a
                href="#!"
                onClick={Physical_WMS_Rp}
                // href={`${
                //   getGlobals().API_BASE_URL
                // }/physicalstock/PhysicalStockCount_Physical_WMS_RP?v_A_RefNo=${
                //   sSummaryObj.RefNo
                // }&A_Loc=${sSummaryObj.loc}`}
              >
                Physical vs WMS vs RP
              </a>
            </Grid>
            <Grid
              item
              md={4}
              xs={6}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
              {/* <CmpButton
                xbtnName=" Stock WMS Vs RP"
                xOnClick={StockWMS_RP}
                xVariant="contained"
                xSize="small"
              /> */}
              <a
                href="#!"
                onClick={StockWMS_RP}
                // href={`${
                //   getGlobals().API_BASE_URL
                // }/physicalstock/PhysicalStockCount_StockWMS_VS_RP?A_Loc=${sSummaryObj.loc}`}
              >
                Stock WMS Vs RP
              </a>
            </Grid>
           
            <Grid
              item
              md={6}
              xs={12}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
              <CmpButton
                xbtnName="Generate Variance"
                xOnClick={Generate_Variance}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              className="bintransfer-data-date "
              justifyContent={"center"}
              textAlign={"center"}
            >
              <CmpButton
                xbtnName="Post Variance"
                xOnClick={Post_Variance}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        </>
      </div>
    </div>
  );
}
